/**
 * Convert a player name to a clean URL slug.
 * "Bijan Robinson" → "bijan-robinson"
 * "Ja'Marr Chase" → "jamarr-chase"
 * "J.J. McCarthy" → "jj-mccarthy"
 */
export function playerToSlug(name) {
  return name
    .toLowerCase()
    .replace(/[.']/g, "")    // Remove apostrophes and periods
    .replace(/\s+/g, "-")    // Spaces to hyphens
    .replace(/-+/g, "-")     // Collapse multiple hyphens
    .replace(/^-|-$/g, "");  // Trim leading/trailing hyphens
}

/**
 * Generate the player page URL path.
 */
export function playerUrl(name) {
  return `/players/${playerToSlug(name)}`;
}

/**
 * Generate comparison page URL with canonical ordering (alphabetical).
 */
export function compareUrl(nameA, nameB) {
  const slugA = playerToSlug(nameA);
  const slugB = playerToSlug(nameB);
  const [first, second] = [slugA, slugB].sort();
  return `/compare/${first}-vs-${second}`;
}
